import { ThemeProvider as T } from "@rmwc/theme";
import "@rmwc/theme/styles";

export const MaterialThemeProvider = T;
